class GoogleAnalytics {
    initialize(trackID, trackDomain) {
        if(!trackID) {
            trackID = 'UA-47612025-6'; // balus localhost
        }

        if (!trackDomain) {
            trackDomain = 'auto';
        }

        ga('create', trackID, trackDomain);
    }

    viewPage() {
        ga('send', 'pageview');
    }

    event(category, action) {
        ga('send', 'event', {
            eventCategory: category,
            eventAction: action
        });
    }
}

module.exports = new GoogleAnalytics();



// WEBPACK FOOTER //
// ./common/infra/google-analytics.js